module.exports = __webpack_public_path__ + "img/subscription-DE.d6b94407.png";